var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 10.6667C9.70152 10.6667 10 10.3682 10 10C10 9.63181 9.70152 9.33333 9.33333 9.33333H6.33333C5.02684 9.33333 4 8.3084 4 7.08333L4 3.58333C4 2.35827 5.02684 1.33333 6.33333 1.33333L12.3333 1.33333C13.6398 1.33333 14.6667 2.35827 14.6667 3.58333V7.08333C14.6667 7.58577 14.4966 8.04963 14.206 8.42575C13.9809 8.71711 14.0346 9.13579 14.326 9.36089C14.6173 9.586 15.036 9.53228 15.2611 9.24092C15.7238 8.6421 16 7.8941 16 7.08333V3.58333C16 1.58673 14.3405 0 12.3333 0H6.33333C4.32612 0 2.66667 1.58674 2.66667 3.58333L2.66667 7.08333C2.66667 9.07993 4.32612 10.6667 6.33333 10.6667L9.33333 10.6667ZM6.66667 5.33333C6.29848 5.33333 6 5.63181 6 6C6 6.36819 6.29848 6.66667 6.66667 6.66667H9.66667C10.9732 6.66667 12 7.6916 12 8.91667V12.4167C12 13.6417 10.9732 14.6667 9.66667 14.6667H3.66667C2.36017 14.6667 1.33333 13.6417 1.33333 12.4167V8.91667C1.33333 8.41423 1.50342 7.95037 1.79401 7.57425C2.01911 7.28289 1.9654 6.86421 1.67403 6.63911C1.38267 6.414 0.963992 6.46772 0.738889 6.75908C0.276244 7.3579 0 8.1059 0 8.91667V12.4167C0 14.4133 1.65945 16 3.66667 16H9.66667C11.6739 16 13.3333 14.4133 13.3333 12.4167V8.91667C13.3333 6.92007 11.6739 5.33333 9.66667 5.33333H6.66667Z",
    fill: "#585C6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8d618264.svg";
export { ForwardRef as ReactComponent };